export default __webpack_public_path__ + "static/media/recordedRed.50a7ab68.svg";